import cc from 'classcat';

interface Props {
    id: string;
    label: string;
    onDeselect: React.MouseEventHandler<HTMLImageElement>;
    className?: string;
}

export const SelectedItem = ({ id, label, onDeselect, className }: Props) => {
    return (
        <div id={id} className={cc(['selected-item', className])}>
            <p className="paragraph-4">{label}</p>
            <img className="selected-item__deselect" src="/svg/x-button.svg" onClick={onDeselect} alt="Deselect" />
        </div>
    );
};
